import { Link } from 'react-router';
import { useToast } from '@contexts/Toast.context';
import { openCookieConsent, isCookiebotInitialized } from '@utils/helpers';

const linkClass = 'text-muted small';

const Footer = ({ linkColSize = 'col-auto' }) => {
	const { addToast } = useToast();
	const linkClassName = `${linkColSize} ${linkClass}`;
	const isInitialized = isCookiebotInitialized();

	const showWarning = () =>
		addToast({
			title: 'Cookie preferences could not be loaded.',
			message: <p className="m-0">Please disable adblockers or strict mode.</p>,
			bg: 'warning',
			id: `cookie-consent-warning-${new Date().getTime()}`,
		});

	return (
		<footer className="pt-5 pb-3 container px-0">
			<nav className="row justify-content-center">
				<Link to="/contact" className={linkClassName}>
					Contact Us
				</Link>
				<Link to="/privacy-policy" className={linkClassName}>
					Privacy Policy
				</Link>
				<Link to="/eula" className={linkClassName}>
					EULA
				</Link>
				<a
					href="#"
					onClick={isInitialized ? openCookieConsent : showWarning}
					className={linkClassName}>
					Cookie Preferences
				</a>
			</nav>
		</footer>
	);
};

export default Footer;
